export default function waitFor(ms = 200) {
  return new Promise(resolve => {
    setTimeout(() => resolve(), ms);
  });
}
